export const typeSafeObjectKeys = <T extends object>(object: T) =>
  Object.keys(object) as (keyof T)[];

export const typeSafeObjectValues = <K extends string, T>(object: { [_ in K]: T }): T[] =>
  Object.values(object);

export const typeSafeFromEntries = <T extends string, U>(
  entries: Iterable<readonly [T, U]>,
): Record<T, U> => Object.fromEntries(entries) as Record<T, U>;

export type EnumToString<T extends string> = `${T}`;
